export default (stringdate) => {
    if (!stringdate) return null;

    let date = null;

    try {
        if (stringdate.includes("-")) {
            // Format: yyyy-mm-dd
            const [year, month, day] = stringdate.split("-");
            date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
        } else if (stringdate.includes(".")) {
            // Format: dd.mm.yyyy
            const [day, month, year] = stringdate.split(".");
            date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
        }
    } catch {
        return null;
    }

    if (!date || isNaN(date.getTime())) return null;

    const isoString = date.toISOString().slice(0, 10); // yyyy-mm-dd
    return `${isoString}T00:00:00.208Z`;
};
